import { createSlice } from '@reduxjs/toolkit';

import type { UserState } from '../../../types/appState';
import { getWidgetRuntimeState } from '../thunks/widgetRuntime.thunk';

const initialState = null as UserState | null;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWidgetRuntimeState.fulfilled, (state, action) => {
      if (action.payload.user) {
        return { ...state, ...action.payload.user };
      }
    });
  },
});
